import React, { useEffect } from 'react'
import styled from 'styled-components'
//import PropTypes from 'prop-types'

const MediaWrap = styled.div`
  width:1820px;
  display: flex; /* 横並び */
  flex-wrap: wrap;
  margin: 4px;
  box-shadow: 0 0 3px 2px 'rgba(0,0,0,0.4)';
  background-color: #649CDF;
  color: #fff;
  font-size: 14px;
  font-weight: bold;

  text-align: center;
  align-items: center;
`
const MediaItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  height: 40px;
  border-right: 2px dashed #fff;
`

const MediaTitle = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 
const MediaHeaderDaily = (props) => {
  const {
  } = props

  // 初期値
  useEffect(() => {
  })

  return (
    <MediaWrap>
      <MediaItem>
        <MediaTitle style={{width:'120px'}}>ID</MediaTitle>
      </MediaItem>
      <MediaItem>
        <MediaTitle style={{width:'130px'}}>グループコード</MediaTitle>
      </MediaItem>
      <MediaItem>
        <MediaTitle style={{width:'130px'}}>会社コード</MediaTitle>
      </MediaItem>
      <MediaItem>
        <MediaTitle style={{width:'150px'}}>店舗コード</MediaTitle>
      </MediaItem>
      <MediaItem>
        <MediaTitle style={{width:'300px'}}>店舗名</MediaTitle>
      </MediaItem>
      <MediaItem>
        <MediaTitle style={{width:'300px'}}>納品センター名</MediaTitle>
      </MediaItem>
      <MediaItem>
        <MediaTitle style={{width:'130px'}}>荷主</MediaTitle>
      </MediaItem>
      <MediaItem>
        <MediaTitle style={{width:'130px'}}>ロケーション</MediaTitle>
      </MediaItem>
      <MediaItem>
        <MediaTitle style={{width:'150px'}}>パターン</MediaTitle>
      </MediaItem>
      <MediaTitle style={{width:'250px'}}>備考</MediaTitle>
    </MediaWrap>
  )
}

MediaHeaderDaily.propTypes = {
}

export default MediaHeaderDaily
